var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.theme ? _vm.theme : ''},[_c('ul',{staticClass:"superNavUl menu clearfix"},[_c('li',{staticClass:"b pr allCommdity navItem"},[_vm._v(" 全部分类 "),_c('Nav',{staticClass:"nav"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }